export default __webpack_public_path__ + "d911cebd997ce2c2b107ad6ef9a92cb0.svg";